import Swiper from 'swiper';

import 'swiper/css/pagination';
import 'swiper/css';
import { Navigation } from 'swiper/modules';

export default class ColumnsSidebar {
	constructor(root) {
		this.root = root;
		this.mediaBlock = root?.querySelector('.media');
		this.contentAreas = root?.querySelectorAll('[data-target="content"]');

		if (this.mediaBlock) {
			this.initMediaBlock();
		}
	}

	initMediaBlock() {
		let mediaItems = [];

		this.contentAreas?.forEach((area) => {
			const items = area.querySelectorAll(
				'img[class*="wp-image-"], iframe[src*="vimeo.com"], iframe[src*="youtube.com"]'
			);
			mediaItems = [...mediaItems, ...items];
		});

		if (mediaItems.length < 1) {
			return;
		}

		const count = this.mediaBlock.querySelector('.media-count');

		if (count) {
			count.textContent = `(${mediaItems.length})`;
		}

		const lightbox = this.mediaBlock.querySelector('.lightbox');
		const lightboxSwiperContainer = lightbox.querySelector('.swiper-wrapper');
		const closeBtns = lightbox?.querySelectorAll('.curtain, .close-btn');

		closeBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				if (e.target === btn) {
					lightbox.classList.remove('active');
				}
			});
		});

		const wrapper = document.createElement('div');
		wrapper.setAttribute('class', 'grid grid-cols-4 gap-2');

		mediaItems.forEach(async (item, i) => {
			let thumbnailUrl = item.getAttribute('src');

			// Prepare lightbox
			if (lightboxSwiperContainer) {
				const clone = item.cloneNode();
				clone.setAttribute('class', 'absolute size-full inset-0 object-cover object-center rounded-2xl');
				const slide = document.createElement('div');
				slide.setAttribute('class', 'swiper-slide relative size-full aspect-[16/9]');
				slide.appendChild(clone);
				lightboxSwiperContainer.appendChild(slide);
			}

			if (item instanceof HTMLIFrameElement) {
				if (item.src.includes('vimeo')) {
					const url = new URL(item.src);
					const id = url.pathname.replace('/video/', '');

					thumbnailUrl = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`)
						.then((res) => res.json())
						.then((data) => data.thumbnail_url);
				} else if (item.src.includes('youtube')) {
					const url = new URL(item.src);
					const id = url.pathname.replace('/embed/', '');
					thumbnailUrl = `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
				} else {
					return;
				}
			}

			const image = document.createElement('img');
			image.src = thumbnailUrl;
			image.setAttribute('class', 'size-full object-center object-cover');

			const thumbnail = document.createElement('div');
			thumbnail.setAttribute(
				'class',
				'relative rounded-lg aspect-[4/3] object-center object-cover overflow-hidden group cursor-pointer'
			);
			thumbnail.addEventListener('click', () => {
				lightbox.classList.add('active');
			});

			const hover = document.createElement('div');
			hover.setAttribute(
				'class',
				'rounded-lg opacity-0 group-hover:opacity-100 bg-black/20 absolute inset-0 transition-all flex justify-center items-center'
			);

			const hoverIcon = document.createElement('i');
			hoverIcon.setAttribute('class', 'fa-solid fa-magnifying-glass-plus text-white');

			thumbnail.appendChild(image);
			thumbnail.appendChild(hover);
			hover.appendChild(hoverIcon);
			wrapper.appendChild(thumbnail);
		});

		new Swiper(lightbox.querySelector('.swiper'), {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: 16,
			loop: true,
			navigation: {
				enabled: true,
				nextEl: lightbox?.querySelector('.swiper-button-next'),
				prevEl: lightbox?.querySelector('.swiper-button-prev'),
			},
		});

		this.mediaBlock.appendChild(wrapper);
	}
}
